import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { FormFeedback, Form, Input, Spinner, Modal, Button, ModalHeader, ModalFooter, CardBody, Card } from 'reactstrap';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import axios from 'axios';
import { ResetPasswordSchema } from 'util/validationSchema';

const ChangePassword = ({ id, token, toggleChangePass, isOpenChangePass }) => {

    const resetData = {
        password: '',
        confirm_password: '',
    };
    const [isLoading, setIsLoading] = useState(false);
    const [isShowpass, setIsShowpass] = useState({
        pass: false,
        cPass: false,
    });

    const handleShowPassword = (pass) => {
        if (pass === 'password') {
            setIsShowpass({ ...isShowpass, pass: !isShowpass.pass });
        }

        if (pass === 'cPassword') {
            setIsShowpass({ ...isShowpass, cPass: !isShowpass.cPass });
        }
    };

    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isValid,
        dirty,
    } = useFormik({
        initialValues: resetData,
        validationSchema: ResetPasswordSchema,
        onSubmit: async (values, actions) => {
            if (values) {
                setIsLoading(true);
                const { password, confirm_password } = values;

                try {
                    const response = await axios.post(
                        `${process.env.REACT_APP_BACKEND_URL}/technician/reset_password/${id}/${token}`,
                        {
                            password,
                            confirm_password,
                        }
                    );

                    if (response.status === 200) {
                        toast.success(response.data.message);
                        actions.resetForm();
                        toggleChangePass();
                    } else {
                        toast.error(response.data.message);
                    }
                } catch (error) {
                    toast.error(error.response ? error.response.data.message : "An error occurred. Please try again.");
                } finally {
                    setIsLoading(false);
                }
            }
        },
    });


    return (
        <>
            {isOpenChangePass && <Card>
                <ModalHeader>
                    Change Account Password
                </ModalHeader>
                <CardBody>
                    <Form>
                        <div className="input-group has-success">
                            <Input
                                type={isShowpass.pass ? 'text' : 'password'}
                                name="password"
                                placeholder="Password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                invalid={touched.password && !!errors.password}
                            />
                            <Button
                                className="btn btn-info"
                                type="button"
                                onClick={() => {
                                    handleShowPassword('password');
                                }}
                            >
                                {isShowpass.pass ? (
                                    <AiOutlineEye />
                                ) : (
                                    <AiOutlineEyeInvisible />
                                )}
                            </Button>
                            <FormFeedback>
                                {touched.password && errors.password && (
                                    <div className="error-message">{errors.password}</div>
                                )}
                            </FormFeedback>
                        </div>
                        <div className="input-group has-success mt-4">
                            <Input
                                type={isShowpass.cPass ? 'text' : 'password'}
                                name="confirm_password"
                                placeholder="confirm password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.confirm_password}
                                invalid={touched.confirm_password && !!errors.confirm_password}
                            />
                            <Button
                                className="btn btn-info"
                                type="button"
                                onClick={() => {
                                    handleShowPassword('cPassword');
                                }}
                            >
                                {isShowpass.cPass ? (
                                    <AiOutlineEye />
                                ) : (
                                    <AiOutlineEyeInvisible />
                                )}
                            </Button>
                            <FormFeedback>
                                {touched.confirm_password && errors.confirm_password && (
                                    <div className="error-message">{errors.confirm_password}</div>
                                )}
                            </FormFeedback>
                        </div>

                        <ModalFooter>
                            <Button color="link" onClick={toggleChangePass}>Cancel</Button>
                            <Button
                                color="primary"
                                onClick={handleSubmit}
                                disabled={isLoading ? true : !(isValid && dirty)}
                            >
                                {isLoading ? (
                                    <Spinner
                                        color="light"
                                        size="sm"
                                    >
                                        Loading...
                                    </Spinner>
                                ) : (
                                    'Change Password'
                                )}
                            </Button>
                        </ModalFooter>
                    </Form>
                </CardBody>
            </Card >
            }
        </>
    );
};

export default ChangePassword;
